/* arubana-cart-drawer.js
   Unified cart: slide-in drawer + floating pill + nav badge.
   Replaces arubana-cart-badge.js.
*/
(function () {
  'use strict';

  var cart = { items: [], item_count: 0, total_price: 0 };
  var drawerOpen = false;
  var lastFocused = null;

  /* ---- Styles ---- */
  var CSS = [
    '#ar-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.4);z-index:9998;opacity:0;',
    'pointer-events:none;transition:opacity 0.3s ease;}',
    '#ar-overlay.ar-active{opacity:1;pointer-events:auto;}',

    '#ar-drawer{position:fixed;top:0;right:0;width:420px;max-width:100vw;height:100%;',
    'background:#F7F1E6;z-index:9999;transform:translateX(100%);',
    'transition:transform 0.35s cubic-bezier(0.4,0,0.2,1);',
    'display:flex;flex-direction:column;font-family:"Mulish",sans-serif;}',
    '#ar-drawer.ar-open{transform:translateX(0);}',

    '.ar-drawer__header{display:flex;align-items:center;justify-content:space-between;',
    'padding:24px 28px 20px;border-bottom:1px solid rgba(81,94,57,0.15);}',
    '.ar-drawer__title{font-family:"Newsreader",serif;font-weight:400;font-size:22px;',
    'color:#2a2a2a;margin:0;}',
    '.ar-drawer__close{background:none;border:none;cursor:pointer;color:#515e39;',
    'padding:4px;display:flex;align-items:center;justify-content:center;line-height:1;}',
    '.ar-drawer__close:hover{opacity:0.7;}',

    '.ar-drawer__body{flex:1;overflow-y:auto;padding:20px 28px;}',

    '.ar-item{display:flex;gap:16px;padding:16px 0;border-bottom:1px solid rgba(81,94,57,0.1);}',
    '.ar-item:last-child{border-bottom:none;}',
    '.ar-item__img{width:72px;height:86px;object-fit:cover;border-radius:4px;',
    'background:#F1E8D8;flex-shrink:0;}',
    '.ar-item__img-ph{width:72px;height:86px;background:#F1E8D8;border-radius:4px;flex-shrink:0;}',
    '.ar-item__info{flex:1;display:flex;flex-direction:column;gap:4px;}',
    '.ar-item__name{font-family:"Newsreader",serif;font-size:15px;color:#2a2a2a;line-height:1.3;}',
    '.ar-item__variant{font-size:12px;color:#999;text-transform:uppercase;letter-spacing:0.06em;}',
    '.ar-item__price{font-size:14px;font-weight:700;color:#515e39;margin-top:4px;}',
    '.ar-item__qty{display:flex;align-items:center;gap:10px;font-size:13px;color:#555;margin-top:2px;}',
    '.ar-item__qty-btn{width:24px;height:24px;border:1px solid rgba(81,94,57,0.3);background:none;',
    'cursor:pointer;border-radius:50%;display:flex;align-items:center;justify-content:center;',
    'font-size:15px;line-height:1;color:#515e39;font-family:"Mulish",sans-serif;}',
    '.ar-item__qty-btn:hover{background:#ede8df;}',
    '.ar-item__remove{background:none;border:none;cursor:pointer;font-size:11px;color:#bbb;',
    'text-decoration:underline;padding:0;font-family:"Mulish",sans-serif;margin-top:2px;}',
    '.ar-item__remove:hover{color:#888;}',

    '.ar-drawer__empty{text-align:center;padding:60px 20px;color:#888;font-size:15px;}',
    '.ar-drawer__empty-title{font-family:"Newsreader",serif;font-size:22px;color:#2a2a2a;',
    'margin:0 0 8px;}',

    '.ar-drawer__footer{padding:20px 28px 28px;border-top:1px solid rgba(81,94,57,0.15);}',
    '.ar-drawer__subtotal{display:flex;justify-content:space-between;font-size:15px;margin-bottom:16px;}',
    '.ar-drawer__subtotal-label{color:#555;}',
    '.ar-drawer__subtotal-amount{font-weight:700;color:#2a2a2a;}',
    '.ar-drawer__note{font-size:11px;color:#aaa;text-align:center;margin-top:10px;',
    'letter-spacing:0.03em;}',

    '.ar-btn{display:block;width:100%;padding:14px;text-align:center;border-radius:2px;',
    'font-family:"Mulish",sans-serif;font-size:12px;font-weight:700;letter-spacing:0.12em;',
    'text-transform:uppercase;text-decoration:none;cursor:pointer;transition:opacity 0.2s;',
    'box-sizing:border-box;}',
    '.ar-btn:hover{opacity:0.85;}',
    '.ar-btn--checkout{background:#515e39;color:#fff;border:none;margin-bottom:10px;}',
    '.ar-btn--cart{background:transparent;color:#515e39;border:1px solid #515e39;}',

    '#ar-cart-pill{position:fixed;bottom:28px;right:28px;z-index:9997;width:56px;height:56px;',
    'border-radius:50%;background:#515e39;color:#fff;border:none;cursor:pointer;',
    'display:none;align-items:center;justify-content:center;',
    'box-shadow:0 4px 20px rgba(0,0,0,0.22);',
    'transition:transform 0.2s ease;flex-shrink:0;}',
    '#ar-cart-pill.ar-pill-visible{display:flex;}',
    '#ar-cart-pill:hover{transform:scale(1.08);}',
    '#ar-pill-count{position:absolute;top:-4px;right:-4px;min-width:18px;height:18px;',
    'padding:0 5px;border-radius:100px;background:#fff;color:#515e39;font-size:10px;',
    'font-weight:800;font-family:"Mulish",sans-serif;display:flex;align-items:center;',
    'justify-content:center;line-height:1;}',

    '.ar-nav-badge{display:inline-flex;align-items:center;justify-content:center;',
    'min-width:22px;height:22px;padding:0 6px;border-radius:100px;background:#E6EDD9;',
    'color:#515e39;font-family:"Mulish",sans-serif;font-size:12px;font-weight:800;',
    'line-height:1;vertical-align:middle;margin-left:6px;}',
    '.ar-nav-badge--hidden{display:none;}',

    '@media(max-width:480px){#ar-drawer{width:100vw;}',
    '#ar-cart-pill{bottom:20px;right:20px;}}'
  ].join('');

  function injectStyles() {
    if (document.getElementById('ar-drawer-styles')) return;
    var s = document.createElement('style');
    s.id = 'ar-drawer-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ---- DOM creation ---- */
  function createElements() {
    var overlay = document.createElement('div');
    overlay.id = 'ar-overlay';
    overlay.addEventListener('click', closeDrawer);
    document.body.appendChild(overlay);

    var drawer = document.createElement('div');
    drawer.id = 'ar-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Shopping cart');
    drawer.innerHTML =
      '<div class="ar-drawer__header">' +
        '<h2 class="ar-drawer__title">Your Cart</h2>' +
        '<button class="ar-drawer__close" aria-label="Close cart">' +
          '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>' +
      '</div>' +
      '<div class="ar-drawer__body" id="ar-drawer-body"></div>' +
      '<div class="ar-drawer__footer" id="ar-drawer-footer"></div>';
    drawer.querySelector('.ar-drawer__close').addEventListener('click', closeDrawer);
    document.body.appendChild(drawer);

    var pill = document.createElement('button');
    pill.id = 'ar-cart-pill';
    pill.setAttribute('aria-label', 'Open cart');
    pill.innerHTML =
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
        '<line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="1.5"/>' +
        '<path d="M16 10a4 4 0 01-8 0" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
      '</svg>' +
      '<span id="ar-pill-count" aria-hidden="true"></span>';
    pill.addEventListener('click', openDrawer);
    document.body.appendChild(pill);
  }

  /* ---- Nav badge ---- */
  function updateNavBadge(count) {
    var links = document.querySelectorAll('a[href="/cart"], a[href$="/cart"]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var badge = link.querySelector('.ar-nav-badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ar-nav-badge ar-nav-badge--hidden';
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      }
      if (count > 0) {
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.classList.remove('ar-nav-badge--hidden');
      } else {
        badge.classList.add('ar-nav-badge--hidden');
      }
    }
  }

  /* ---- Floating pill ---- */
  function showPill(count) {
    var pill = document.getElementById('ar-cart-pill');
    var countEl = document.getElementById('ar-pill-count');
    if (!pill) return;
    if (count > 0) {
      if (countEl) countEl.textContent = count > 99 ? '99+' : String(count);
      pill.classList.add('ar-pill-visible');
    } else {
      pill.classList.remove('ar-pill-visible');
    }
  }

  function hidePill() {
    var pill = document.getElementById('ar-cart-pill');
    if (pill) pill.classList.remove('ar-pill-visible');
  }

  /* ---- Format price ---- */
  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    var parts = dollars.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts[0] + '.' + parts[1];
  }

  /* ---- Render ---- */
  function renderDrawer() {
    var body = document.getElementById('ar-drawer-body');
    var footer = document.getElementById('ar-drawer-footer');
    if (!body || !footer) return;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML =
        '<div class="ar-drawer__empty">' +
          '<p class="ar-drawer__empty-title">Your cart is empty</p>' +
          '<p>Add something beautiful.</p>' +
        '</div>';
      footer.innerHTML = '';
      return;
    }

    var rows = '';
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var img = item.image
        ? '<img class="ar-item__img" src="' + item.image + '" alt="" loading="lazy">'
        : '<div class="ar-item__img-ph"></div>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="ar-item__variant">' + escHtml(item.variant_title) + '</div>'
        : '';
      rows +=
        '<div class="ar-item" data-key="' + escHtml(item.key) + '">' +
          img +
          '<div class="ar-item__info">' +
            '<div class="ar-item__name">' + escHtml(item.product_title) + '</div>' +
            variant +
            '<div class="ar-item__qty">' +
              '<button class="ar-item__qty-btn" data-key="' + escHtml(item.key) + '" data-delta="-1" aria-label="Decrease quantity">-</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button class="ar-item__qty-btn" data-key="' + escHtml(item.key) + '" data-delta="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="ar-item__price">' + formatMoney(item.final_line_price) + '</div>' +
            '<button class="ar-item__remove" data-key="' + escHtml(item.key) + '">Remove</button>' +
          '</div>' +
        '</div>';
    }

    body.innerHTML = rows;

    footer.innerHTML =
      '<div class="ar-drawer__subtotal">' +
        '<span class="ar-drawer__subtotal-label">Subtotal</span>' +
        '<span class="ar-drawer__subtotal-amount">' + formatMoney(cart.total_price) + '</span>' +
      '</div>' +
      '<a href="/checkout" class="ar-btn ar-btn--checkout">Checkout</a>' +
      '<a href="/cart" class="ar-btn ar-btn--cart">View Full Cart</a>' +
      '<p class="ar-drawer__note">Shipping & taxes calculated at checkout</p>';
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ---- Open / Close ---- */
  function openDrawer() {
    if (drawerOpen) return;
    drawerOpen = true;
    lastFocused = document.activeElement;
    hidePill();
    var overlay = document.getElementById('ar-overlay');
    var drawer = document.getElementById('ar-drawer');
    if (overlay) overlay.classList.add('ar-active');
    if (drawer) drawer.classList.add('ar-open');
    document.body.style.overflow = 'hidden';
    if (drawer) {
      var closeBtn = drawer.querySelector('.ar-drawer__close');
      if (closeBtn) closeBtn.focus();
    }
  }

  function closeDrawer() {
    if (!drawerOpen) return;
    drawerOpen = false;
    var overlay = document.getElementById('ar-overlay');
    var drawer = document.getElementById('ar-drawer');
    if (overlay) overlay.classList.remove('ar-active');
    if (drawer) drawer.classList.remove('ar-open');
    document.body.style.overflow = '';
    showPill(cart.item_count);
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
    lastFocused = null;
  }

  /* ---- Cart API || ---- */
  function fetchCart(cb) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart = data;
        if (cb) cb();
      })
      .catch(function () { if (cb) cb(); });
  }

  function changeQty(key, newQty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty }),
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) { throw new Error('cart'); }
        return r.json();
      })
      .then(function (data) {
        cart = data;
        renderDrawer();
        updateNavBadge(cart.item_count);
        if (drawerOpen && cart.item_count === 0) {
          closeDrawer();
        }
      })
      .catch(function () {
        fetchCart(function () {
          renderDrawer();
          updateNavBadge(cart.item_count);
        });
      });
  }

  /* ---- Intercept add-to-cart fetch ---- */
  function interceptFetch() {
    var orig = window.fetch;
    window.fetch = function (url, opts) {
      var promise = orig.apply(this, arguments);
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      if (urlStr.indexOf('/cart/add') !== -1) {
        promise.then(function (res) {
          if (res && res.ok) {
            fetchCart(function () {
              renderDrawer();
              updateNavBadge(cart.item_count);
              openDrawer();
            });
          }
        }).catch(function () {});
      }
      return promise;
    };
  }

  /* ---- Event delegation ---- */
  function bindEvents() {
    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest && e.target.closest('.ar-item__qty-btn');
      if (qtyBtn) {
        var key = qtyBtn.getAttribute('data-key');
        var delta = parseInt(qtyBtn.getAttribute('data-delta'), 10);
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) {
            var newQty = cart.items[i].quantity + delta;
            changeQty(key, newQty < 0 ? 0 : newQty);
            break;
          }
        }
        return;
      }
      var removeBtn = e.target.closest && e.target.closest('.ar-item__remove');
      if (removeBtn) {
        changeQty(removeBtn.getAttribute('data-key'), 0);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawerOpen) closeDrawer();
    });
  }

  /* ---- Init ---- */
  function init() {
    injectStyles();
    createElements();
    bindEvents();
    interceptFetch();
    fetchCart(function () {
      updateNavBadge(cart.item_count);
      if (cart.item_count > 0) showPill(cart.item_count);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
